export { AtnDetailsTabComponent as Component } from './details-tab.component'
